// (c) 2023 Acellera Ltd http://www.acellera.com
// All Rights Reserved
// No redistribution in whole or part
//
import { Box } from "@mui/material";
import { styled } from "@mui/material/styles";
export const LLMMessageWrapper = styled(Box, {
    shouldForwardProp: (prop) => prop !== "isError",
})(({ theme, isError }) => ({
    alignSelf: "flex-start",
    color: isError ? theme.palette.error.light : theme.palette.common.white,
    borderRadius: theme.shape.borderRadius,
    padding: theme.spacing(1),
    maxWidth: "100%",
    // marginBottom: theme.spacing(1),
    fontSize: "0.8em",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
}));
export const UserMessageWrapper = styled(Box)(({ theme }) => ({
    alignSelf: "flex-end",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.primary.contrastText,
    borderRadius: "20px",
    padding: theme.spacing(1),
    maxWidth: "70%",
    fontSize: "0.8em",
    wordWrap: "break-word",
    whiteSpace: "pre-wrap",
    marginTop: theme.spacing(1),
}));
